import { ApolloLink, FetchResult, Operation, NextLink, Observable } from '@apollo/client';
import { ToastProps } from '@ui-components/neo.tax';

import { ToastConfigState } from '@neo.tax/shared/state';

class ToastLink extends ApolloLink {
  public request(operation: Operation, forward: NextLink): Observable<FetchResult> {
    const { errorToast, loadingToast, successToast } = operation.getContext();

    let loadingToastId: string | undefined;
    if (loadingToast) {
      const toast = ToastConfigState.pushToast({
        ...loadingToast,
        severity: 'neutral',
        duration: loadingToast.duration ?? 'INFINITE',
      });
      loadingToastId = toast.id;
    }

    return forward(operation).map((result) => {
      if (loadingToastId) {
        ToastConfigState.removeToast(loadingToastId);
      }
      if (successToast && !result.errors) {
        ToastConfigState.pushSuccessToast(successToast.title, {
          id: operation.operationName,
          duration: successToast.duration,
          description: successToast.description,
        });
      }
      if (errorToast && result.errors) {
        ToastConfigState.pushErrorToast(errorToast.title, {
          id: operation.operationName,
          duration: errorToast.duration,
          description: errorToast.description,
        });
      }
      return result;
    });
  }
}

/// <reference types="@apollo/client" />
declare module '@apollo/client' {
  interface DefaultContext {
    /**
     * If provided, toast will be shown on success with the provided toast options.
     */
    successToast?: Pick<ToastProps, 'title' | 'description' | 'duration'>;

    /**
     * If provided, toast will be shown on error with the provided toast options.
     */
    errorToast?: Pick<ToastProps, 'title' | 'description' | 'duration'>;
    /**
     * If provided, toast will be shown while the request is in flight.
     */
    loadingToast?: Pick<ToastProps, 'title' | 'description' | 'duration'>;
  }
}

export const toastLink = new ToastLink();
